import React from 'react';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Box, IconButton, Tooltip } from '@mui/material';

import { styled } from 'styled-components';

import { colors } from 'theme/colors';

const StyledIconButton = styled(IconButton)`
  &:hover {
    svg {
      fill: ${({ theme }) => theme.palette.primary.main};
      rect {
        fill: ${({ theme }) => theme.palette.primary.main};
        fill-opacity: 1;
      }
    }
  }
`;

const SectionTooltipAction: React.FC<{
  addCondition: () => void;
  children: React.ReactElement;
}> = ({ addCondition, children }): React.ReactElement => (
  <Tooltip
    placement="right"
    componentsProps={{
      tooltip: {
        sx: {
          color: colors.common.black,
          padding: '4px',
          background: colors.common.white,
          borderRadius: '6px',
          border: `1px solid ${colors.divider}`,
          boxShadow: colors.shadows.card[200],
        },
      },
    }}
    title={
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Tooltip title="Add condition" placement="right-end">
          <StyledIconButton onClick={addCondition}>
            <AddCircleIcon />
          </StyledIconButton>
        </Tooltip>
      </Box>
    }
  >
    {children}
  </Tooltip>
);

export default SectionTooltipAction;
